import { Loader2 } from 'lucide-react';
import { Button } from '~/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/components/ui/card';
import { Badge } from '~/components/ui/badge';

interface IIntegrationCardProps {
  name: string;
  description: string;
  icon: React.ReactNode;
  connected: boolean;
  connectedBy?: string;
  connectedAt?: string;
  loading: boolean;
  error: string | null;
  onConnect: () => void;
  onDisconnect: () => void;
}

export const IntegrationCard = ({
  name,
  description,
  icon,
  connected,
  connectedBy,
  connectedAt,
  loading,
  error,
  onConnect,
  onDisconnect,
}: IIntegrationCardProps) => {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center gap-4 space-y-0">
        <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-muted">{icon}</div>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <CardTitle className="text-lg">{name}</CardTitle>
            {connected && <Badge className="bg-green-100 text-green-800 hover:bg-green-100">Connected</Badge>}
          </div>
          <CardDescription>{description}</CardDescription>
        </div>
      </CardHeader>
      <CardContent>
        {error && <p className="text-sm text-red-600 mb-3">{error}</p>}

        {connected && connectedBy && (
          <p className="text-sm text-muted-foreground mb-3">
            Connected by {connectedBy}
            {connectedAt && ` on ${new Date(connectedAt).toLocaleDateString()}`}
          </p>
        )}

        <div className="flex gap-2">
          {connected ? (
            <Button variant="outline" size="sm" onClick={onDisconnect} disabled={loading}>
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Disconnect
            </Button>
          ) : (
            <Button size="sm" onClick={onConnect} disabled={loading}>
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Connect
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
